import { render, staticRenderFns } from "./BridgeLogView.vue?vue&type=template&id=40564349"
import script from "./BridgeLogView.vue?vue&type=script&lang=ts"
export * from "./BridgeLogView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports